import { render, staticRenderFns } from "./UserSmsHistory.vue?vue&type=template&id=659a0396&"
import script from "./UserSmsHistory.vue?vue&type=script&lang=js&"
export * from "./UserSmsHistory.vue?vue&type=script&lang=js&"
import style0 from "./UserSmsHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports